class VideoLoader {
  key = "video";

  #videoExtensions = ".mp4";
  #videoType = "video/mp4";

  async load(assetsPath) {
    return new Promise((resolve, reject) => {
      const sourceVideo = document.createElement("video");
      document.body.appendChild(sourceVideo);

      sourceVideo.type = this.#videoType;
      sourceVideo.muted = true;
      sourceVideo.playsInline = true;
      sourceVideo.crossOrigin = "anonymous";
      sourceVideo.preload = "metadata";

      sourceVideo.addEventListener("loadedmetadata", () => {
        // TODO chrome does not always dispatch this event
        // it is probably/hopefully only when running locally
        // still, has to be addressed

        document.body.removeChild(sourceVideo);
        resolve({
          content: sourceVideo,
          representation: {
            videoWidth: sourceVideo.videoWidth,
            videoHeight: sourceVideo.videoHeight,
            length: sourceVideo.duration * 1000,
          },
        });
      });

      sourceVideo.addEventListener("error", () => {
        document.body.removeChild(sourceVideo);
        console.warn(`[AssetLoader] Failed to load video: ${assetsPath}`);
        reject(new Error(`Video not found: ${assetsPath}`));
      });

      sourceVideo.src = assetsPath;
    });
  }
}

const videoLoader = new VideoLoader();
export { videoLoader, VideoLoader };
